export default __webpack_public_path__ + "static/media/logo-horizontal.009c07dd.svg";